import { render } from "./PageViewer.vue?vue&type=template&id=99dd6bb6&scoped=true"
import script from "./PageViewer.vue?vue&type=script&lang=js"
export * from "./PageViewer.vue?vue&type=script&lang=js"

import "./PageViewer.vue?vue&type=style&index=0&id=99dd6bb6&scoped=true&lang=scss"

import exportComponent from "/app/src/client/.yarn/__virtual__/vue-loader-virtual-e12e5a5897/0/cache/vue-loader-npm-17.0.1-f552b82805-b10a7b05ba.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99dd6bb6"]])

export default __exports__